export enum ContentType {
    JSON = 'application/json',
    MULTIPART_FORMDATA = 'multipart/form-data',
    OCTET_STREAM = 'application/octet-stream'
}
